var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedIn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0077B5",
    d: "M0 22.5C0 10.074 10.074 0 22.5 0S45 10.074 45 22.5 34.926 45 22.5 45 0 34.926 0 22.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M28.419 18.276c3.355 0 5.87 2.19 5.87 6.896v8.784H29.19v-8.197c0-2.058-.737-3.463-2.583-3.463-1.409 0-2.248.947-2.617 1.862-.134.327-.167.784-.167 1.242v8.556h-5.1s.067-13.883 0-15.32h5.1v2.17c.676-1.043 1.888-2.53 4.596-2.53zm-12.518.36v15.32h-5.1v-15.32h5.1zm-2.516-7.386c1.744 0 2.818 1.144 2.851 2.646 0 1.417-1.026 2.56-2.69 2.644l-.195.004h-.032c-1.712 0-2.819-1.177-2.819-2.648 0-1.502 1.14-2.646 2.885-2.646z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/linked-in.65385abe00dc6fb01e346e834c2939dd.svg";
export { ForwardRef as ReactComponent };